<template>
  <div id="app">
    <navigation-menu v-bind:hidden="hideMenu"  >
       <router-view ></router-view>
       <router-view slot="other" name="other"></router-view> 
    </navigation-menu>
  </div>
</template>

<script>
import NavigationMenu from "./components/NavigationMenu.vue";

export default {
  name: 'app',
  components: {
    NavigationMenu
  },
  methods: {
    setupHeader() {
      if(this.$route.name == 'Login' || this.$route.name == 'AccountLogout' || this.$route.name ==  'AccountValidate' ||  this.$route.name == 'CreateAccount') {
        this.hideMenu = true;
      }
      else {
         if(localStorage.getItem("access_token") != null) {
           this.hideMenu = false;
         }
         else {
           this.hideMenu = true;
           if(this.$route.name != 'Login') {
             this.$router.push({ name: 'Login' });
           }
         }
      }
    }
  },
  created() {
    this.setupHeader();
  },
  data() {
    return {
      hideMenu: true
    }
  },
  watch:{
    $route () {
      this.setupHeader();
    }
  } 
}
</script>

<style>
  .hidden {
    display: none;
  }
</style>
